<template>
  <div>
    <v-select
        v-model="selectedOrg"
        :items="orgs"
        label="Organisations"
        item-text="name"
        :loading="loading > 0"
        :disabled="disabled"
        outlined
        return-object
        
        @change="orgChanged"
      />
    </div>
</template>

<script>
import { ListAccessibleOrgs } from "@/services/API"
import { Logger } from "aws-amplify"

const logger = new Logger("ORG SELECT")

export default {
  props: {
    value: {
      type: [String, Boolean],
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },

  data () {
    return {
      oldVal: false,
      selectedOrg: false,
      orgs: [],
      loading: 0,
    }
  },

  watch: {
    disabled () {
      this.$refs.test.blur()
    }
  },

  mounted () {
    // incase an input is passed down to this component to prepopulate, we set the value here
    this.selectedOrg = this.value
    this.oldVal = JSON.parse(JSON.stringify(this.value))

    // populate our org list, if we can do that from store instead we should do so here
    this.loading++
    ListAccessibleOrgs().then(res => {
      this.orgs = res.map(i => ({ id: i.id, name: i.name }))
      this.loading--
    }).catch(err => {
      this.loading--
      logger.debug("err", err)
    })
  },

  methods: {
    // we admit input here when the value is changed to adhere to v-model
    orgChanged (info) {
      if(this.disabled) {
        this.selectedOrg = JSON.parse(JSON.stringify(this.oldVal))
        return
      }

      // annoying way to ensure the user doesn't set the state of the component to be viewing a different org to the one we are loading
      this.oldVal = info
      logger.debug("org changed", info.id)
      this.$emit('input', info.id)
      this.$emit('orgName', info.name)
    }
  }
}
</script>
